module.exports = __webpack_public_path__ + "static/media/gris_numero_principal.9fad2f45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/gris_numero_principal.svg
// module id = 1754
// module chunks = 0